import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC} from 'react';
import {ModalContent, ModalWrapper} from './EditAccessRightsModal.styles';
import Text from '@atoms/Text';
import Button from '@atoms/Button';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '@store';
import {deletePlan, selectCoveragePlans} from '@store/slices/coveragePlans';
import {formatNonTodayFull} from '@utils/common';
import {PlansList, PlanItemRow, PlanItemActions} from './ViewSystemPlansModal.styles';
import {Edit, TrashCan, ViewFilled} from '@carbon/icons-react';
import {theme} from '@styles/theme';

interface Props {
  isOpened: boolean;
  onCloseRequest: () => void;
}

const ViewSystemPlansModal: FC<Props> = ({isOpened, onCloseRequest}) => {
  const {id} = useParams<{id: string}>();
  const systemIdNum = Number(id);
  const plans = useSelector(selectCoveragePlans);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader title={'Список планов покрытия'} onClose={onCloseRequest} />
        <ModalContent>
          <Text
            text={'Название Cистемы Long-Smart Placeholder 50 Char MAX'}
            type="captionB"
          />
          <PlansList>
            {plans.length === 0 && <Text text={'Планы ещё не созданы'} type="bodyR" />}
            {plans.map((p, idx) => {
              const d = new Date(p.date);
              d.setHours(0, 0, 0, 0);
              const dateText = formatNonTodayFull(d).replace(',', '');
              return (
                <PlanItemRow key={p.id}>
                  <Text text={`${idx + 1}. ${dateText}`} type="bodyM" />
                  <PlanItemActions>
                    <Button
                      variant="text"
                      iconElement={<ViewFilled size={16} color={theme.colors.basic00} />}
                      onClick={() => {
                        onCloseRequest();
                        navigate(
                          `/systems/${systemIdNum}/plan?date=${p.date}&readonly=1`,
                        );
                      }}
                    />
                    <Button
                      variant="text"
                      iconElement={<Edit size={16} color={theme.colors.basic00} />}
                      onClick={() => {
                        onCloseRequest();
                        navigate(`/systems/${systemIdNum}/plan?date=${p.date}`);
                      }}
                    />
                    <Button
                      variant="text"
                      iconElement={<TrashCan size={16} color={theme.colors.basic00} />}
                      onClick={() => {
                        dispatch(deletePlan({plan_id: p.id}));
                      }}
                    />
                  </PlanItemActions>
                </PlanItemRow>
              );
            })}
          </PlansList>
        </ModalContent>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default ViewSystemPlansModal;
